<template>
  <tr>
    <td>{{ item.id }}</td>
    <td>{{ item.time_start }}</td>
    <td>{{ item.count_player }}</td>
    <td v-for="(item, index) in sectorsValue" :key="index">{{ item }}</td>
    <td>{{ item.win_sector.value.value }}</td>
    <td>{{ item.total }}</td>
  </tr>
</template>

<script>
export default {
  name: 'GameStatisticsItem',
  props: {
    item: Object
  },
  data () {
    return {
      sectors: [1, 2, 5, 10, 20, 40],
      sectorsValue: []
    }
  },
  watch: {
    item () {
      this.sectorsValue = []
      this.sectors.forEach(item => {
        this.sectorsValue.push(this.getSector(item))
      })
    }
  },
  mounted () {
    this.sectors.forEach(item => {
      this.sectorsValue.push(this.getSector(item))
    })
  },
  methods: {
    getSector (sector) {
      const regExp = `^${sector}\\/.+`
      const sectorInfo = this.item.sector_betting.find(item => item.search(new RegExp(regExp)) !== -1)
      if (sectorInfo !== undefined)
        return sectorInfo.substr(sectorInfo.indexOf('/') + 1, sectorInfo.length - sectorInfo.indexOf('/') - 1)

      return '0/0'
    }
  }
}
</script>

<style scoped>

</style>
